import { defineMessages } from "react-intl";
import { stdnum } from "stdnum";

const FR_TAX_IDS = {
  NUM_FISCAL: "NUM_FISCAL",
  SIREN_SIRET: "SIREN_SIRET",
};

const FR_TAX_IDS_META = {
  [FR_TAX_IDS.NUM_FISCAL]: {
    type: FR_TAX_IDS.NUM_FISCAL,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.num_fiscal_short_name",
        defaultMessage: "Tax Number",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.num_fiscal_name",
        defaultMessage: "Tax Number",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.num_fiscal_full_name",
        defaultMessage: "Tax Number",
      },
    }),
    validationFn: stdnum.FR.nif.validate,
    format: "00 00 000 0000 00",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.num_fiscal_format",
        defaultMessage: "13-digit",
      },
    }),
  },
  [FR_TAX_IDS.SIREN_SIRET]: {
    type: FR_TAX_IDS.SIREN_SIRET,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.siren_siret_short_name",
        defaultMessage: "SIREN/SIRET",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.siren_siret_name",
        defaultMessage: "SIREN or SIRET",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.siren_siret_full_name",
        defaultMessage: "SIREN or SIRET",
      },
    }),
    validationFn: (value) => {
      const siren = stdnum.FR.siren.validate(value);
      const siret = stdnum.FR.siret.validate(value);
      return siren.isValid ? siren : siret;
    },
    format: "000 000 000 or 000 000 000 00000",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.siren_siret_format",
        defaultMessage: "9-digit (SIREN) or 14-digit (SIRET)",
      },
    }),
  },
};

const FR_VAT_IDS = {
  NUM_TVA: "NUM_TVA",
};

const FR_VAT_IDS_META = {
  [FR_VAT_IDS.NUM_TVA]: {
    type: FR_VAT_IDS.NUM_TVA,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.num_tva_short_name",
        defaultMessage: "VAT ID",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.num_tva_name",
        defaultMessage: "Value-Added Tax Identification Number",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.num_tva_full_name",
        defaultMessage: "Value-Added Tax Identification Number (VAT ID)",
      },
    }),
    validationFn: stdnum.FR.tva.validate,
    format: "FR XX 000 000 000",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.num_tva_format",
        defaultMessage: "2 letters, 2 alphanumeric characters, 9 digits",
      },
    }),
  },
};

export { FR_TAX_IDS, FR_TAX_IDS_META, FR_VAT_IDS, FR_VAT_IDS_META };
